import { render, staticRenderFns } from "./groupBuyOrderdetail.vue?vue&type=template&id=8c596d72&scoped=true&"
import script from "./groupBuyOrderdetail.vue?vue&type=script&lang=js&"
export * from "./groupBuyOrderdetail.vue?vue&type=script&lang=js&"
import style0 from "./groupBuyOrderdetail.vue?vue&type=style&index=0&id=8c596d72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c596d72",
  null
  
)

export default component.exports